// extracted by mini-css-extract-plugin
export default {"stack":"TimingInfo_stack__uxsbt","divider":"TimingInfo_divider__vJnuy"};